import { render, staticRenderFns } from "./AllModels.vue?vue&type=template&id=b760950c"
import script from "./AllModels.vue?vue&type=script&lang=js"
export * from "./AllModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports